<template>
  <div class="platform-selector">
    <h3
      v-if="!noTitle"
      class="h3"
    >
      Server Bundles
    </h3>
    <div class="node-form__tags tags">
      <md-autocomplete
        ref="serverInput"
        v-model="input"
        class="tags__input"
        :md-options="options"
        :md-fuzzy-search="false"
        @md-selected="addServerBundle"
      >
        <label>Choose server bundles</label>

        <template
          slot="md-autocomplete-item"
          slot-scope="{ item, term }"
        >
          <md-highlight-text :md-term="term">
            {{ item.name }}
          </md-highlight-text>
        </template>
      </md-autocomplete>

      <md-chip
        v-for="bundle in selected"
        :key="bundle.name"
        class="md-primary"
        md-deletable
        style="margin-right: 3px !important;"
        @click="deleteChip(bundle)"
      >
        {{ bundle.name }}
      </md-chip>
    </div>
  </div>
</template>
<script>
    export default {
        name: "ServerBundlesSelector",
        props: {
          initialServerBundles: { type: Array, default: () => [] },
          noTitle: { type: Boolean }
        },
        data() {
            return {
                options: [],
                input: "",
                selected: [],

                dictionary: [],
            };
        },
        watch: {
            "initialServerBundles": "updateBundlesFromProps",
        },
        mounted() {
            this.fetchServerBundles();
            // if props are passed, use them as the initial state
            if (this.$props.initialServerBundles) {
                this.updateBundlesFromProps();
            }
        },
        methods: {
            emitBundleUpdate() {
                this.$emit("serverListChanged", this.selected);
            },
            addServerBundle(bundle) {
                this.selected.push(bundle);

                this.emitBundleUpdate();
                this.input = "";
                this.$refs.serverInput.$data.searchTerm = "";
            },
            deleteChip(bundle) {
                this.selected = this.selected.filter(el => {
                    return el.id !== bundle.id;
                });

                this.emitBundleUpdate();
            },
            fetchServerBundles() {
                this.$http.get("/v1/admin/node/server-bundles").then(
                    res => {
                        this.options = res.data.server_bundles;
                    },
                    err => {
                        console.error(err);
                    },
                );
            },
            updateBundlesFromProps() {
                this.selected = this.$props.initialServerBundles || [];
            },
        }
    };
</script>
